import * as yup from 'yup'

export default yup.object().shape({
  name: yup.string().min(1).required('Required field'),
  email: yup.string().email(),
  password: yup.string(),
})
